export class ClinicSummaryRequest {
  private Action = 'getclinicsummary';
  public PublicToken: string;

  constructor({ PublicToken }) {
    this.PublicToken = PublicToken;
  }
}
